import { motion, useScroll, useSpring } from 'framer-motion';

export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-1 z-[60] origin-left"
      style={{ 
        scaleX,
        background: 'linear-gradient(90deg, hsl(217 91% 53%) 0%, hsl(213 100% 14%) 50%, hsl(0 0% 100%) 100%)',
      }}
    />
  );
}